import Row from "./row";
import Column from "./column";

export default {
	Row,
	Column,
};
